// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./admin-variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared Admin Form Styles */

/* Form Container */
.admin-form-container {
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Main container for card-less layout */
.admin-form-main-container {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 1rem 2rem;
  border-radius: var(--radius-xl);
}

/* Page Header */
.admin-form-header {
  background-color: #7d48b0;
  padding: 4px 8px;
  border-radius: 4px;
  color: white !important;
    margin-bottom: 0.5rem;
}

.admin-form-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--surface-white);
  text-transform: uppercase;
  text-align: left;
}

/* Modern Form Layout */
.admin-modern-form {
  width: 100%;
}

/* Form Content Wrapper */
.admin-form-content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  margin-bottom: 2rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #9ca3afa1;
    transform: translateX(-50%);
  }

  @media (max-width: 1400px) {
    grid-template-columns: 1fr 450px;
    gap: 3rem;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

/* Form Columns */
.admin-form-left-column {
  flex: 1;
}

.admin-form-right-column {
  width: 100%;

  @media (max-width: 1400px) {
    max-width: 450px;
  }

  @media (max-width: 1200px) {
    max-width: none;
  }
}

/* Form Sections */
.admin-form-section {
  margin-bottom: 2rem;
}

/* Bottom Submit Button */
.admin-form-actions-bottom {
  text-align: center;
  padding: 2rem 0 1rem;
  border-top: 2px solid var(--border-light);
  margin-top: 2rem;
}

/* Compact Grid System */
.admin-form-grid {
  display: grid;
  gap: 1rem;
}

.admin-form-grid-two-columns {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.admin-form-grid-three-columns {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

/* Compact Form Item Styling */
.admin-modern-form .ant-form-item {
  margin-bottom: 0.75rem;

  .ant-form-item-label {
    padding-bottom: 0.25rem;
    margin-bottom: 0;

    > label {
      font-weight: 500;
      color: var(--text-primary);
      font-size: 0.875rem;
      text-transform: none;
      letter-spacing: 0;
      line-height: 1.4;

      &::after {
        content: none;
      }

      &.ant-form-item-required::before {
        content: "*";
        color: var(--danger-color);
        font-weight: bold;
        margin-right: 4px;
        font-size: 0.9rem;
      }
    }
  }

  .ant-form-item-control {
    margin-bottom: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

/* Compact Input Styling */
.admin-modern-form .ant-input,
.admin-modern-form .ant-input-password,
.admin-modern-form .ant-select-selector,
.admin-modern-form .ant-picker {
  border: 1px solid #d1d5db !important;
  border-radius: var(--radius-md);
  padding: 8px 12px;
  font-size: 0.9rem;
  font-weight: 400;
  transition: all 0.2s ease;
  background: var(--surface-white);
  height: 38px;
  line-height: 1.4;

  &:hover {
    border-color: var(--primary-light);
    box-shadow: 0 0 0 1px rgba(239, 130, 0, 0.2);
  }

  &:focus,
  &.ant-input-focused,
  &.ant-select-focused {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(239, 130, 0, 0.2);
  }
}

/* Fix password input alignment */
.admin-modern-form .ant-input-password {
  .ant-input {
    border: none !important;
    padding: 0;
    height: auto;
    line-height: 1.4;
    display: flex;
    align-items: center;
    box-shadow: none !important;
  }

  .ant-input-suffix {
    display: flex;
    align-items: center;
  }
}

/* Enhanced Checkbox and Radio Styling */
.admin-modern-form .ant-checkbox-wrapper,
.admin-modern-form .ant-radio-wrapper {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border: 1px solid #9ca3af;
  border-radius: var(--radius-md);
  transition: all 0.2s ease;
  background: var(--surface-gray-50);

  &:hover {
    background: var(--surface-white);
    border-color: var(--primary-light);
    box-shadow: var(--shadow-sm);
  }
}

/* Permissions Grid Layout */
.admin-permissions-grid {
  .ant-checkbox-group {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 0.75rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
}

.admin-modern-form .ant-checkbox-wrapper {
  width: 100%;

  .ant-checkbox {
    .ant-checkbox-inner {
      width: 20px;
      height: 20px;
      border-radius: var(--radius-sm);
      border: 2px solid #9ca3af !important;
      transition: all 0.2s ease;

      &::after {
        width: 6px;
        height: 10px;
        border-width: 0 3px 3px 0;
      }
    }

    &.ant-checkbox-checked .ant-checkbox-inner {
      background: var(--primary-gradient);
      border-color: var(--primary-color);
    }
  }

  span:last-child {
    font-weight: 500;
    color: var(--text-primary);
    margin-left: 0.5rem;
  }
}

/* Submit Button */
.admin-create-btn {
  min-width: 220px;
  height: 44px;
  font-size: 1rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  border: none;
  border-radius: var(--radius-md);
  background: var(--primary-color);
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;

  &:hover {
    background: #d97706;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(1px);
  }

  &[disabled] {
    background: var(--text-muted);
    box-shadow: none;
    transform: none;
  }
}

/* Custom Editor Styling */
.admin-custom-editor-wrapper {
  border: 2px solid var(--border-light);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: all 0.2s ease;
  background: var(--surface-white);

  &:hover {
    border-color: var(--primary-light);
    box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);
  }

  &:focus-within {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 4px rgb(239 130 0 / 0.15);
  }

  .admin-form-right-column & {
    margin-top: 0;
    min-height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./styles/admin-forms.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAG7B,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;IACrB,qBAAqB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,iBAAiB;AACjB;EACE,OAAO;AACT;;AAEA;EACE,WAAW;;EAEX;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;;EAE9B;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kCAAkC;;EAElC;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;;EAEtB;IACE,uBAAuB;IACvB,gBAAgB;;IAEhB;MACE,gBAAgB;MAChB,0BAA0B;MAC1B,mBAAmB;MACnB,oBAAoB;MACpB,iBAAiB;MACjB,gBAAgB;;MAEhB;QACE,aAAa;MACf;;MAEA;QACE,YAAY;QACZ,0BAA0B;QAC1B,iBAAiB;QACjB,iBAAiB;QACjB,iBAAiB;MACnB;IACF;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,0BAA0B;AAC1B;;;;EAIE,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;;EAEhB;IACE,kCAAkC;IAClC,4CAA4C;EAC9C;;EAEA;;;IAGE,kCAAkC;IAClC,4CAA4C;EAC9C;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,wCAAwC;AACxC;;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,kCAAkC;;EAElC;IACE,gCAAgC;IAChC,kCAAkC;IAClC,4BAA4B;EAC9B;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,WAAW;IACX,aAAa;IACb,2DAA2D;IAC3D,YAAY;;IAEZ;MACE,0BAA0B;IAC5B;EACF;AACF;;AAEA;EACE,WAAW;;EAEX;IACE;MACE,WAAW;MACX,YAAY;MACZ,+BAA+B;MAC/B,oCAAoC;MACpC,yBAAyB;;MAEzB;QACE,UAAU;QACV,YAAY;QACZ,yBAAyB;MAC3B;IACF;;IAEA;MACE,mCAAmC;MACnC,kCAAkC;IACpC;EACF;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;;EAEzB;IACE,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;;EAEhC;IACE,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA;IACE,kCAAkC;IAClC,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":["/* Shared Admin Form Styles */\r\n@import './admin-variables.css';\r\n\r\n/* Form Container */\r\n.admin-form-container {\r\n  width: 100%;\r\n  padding: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Main container for card-less layout */\r\n.admin-form-main-container {\r\n  width: 100%;\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n  padding: 1rem 2rem;\r\n  border-radius: var(--radius-xl);\r\n}\r\n\r\n/* Page Header */\r\n.admin-form-header {\r\n  background-color: #7d48b0;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  color: white !important;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.admin-form-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  color: var(--surface-white);\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n}\r\n\r\n/* Modern Form Layout */\r\n.admin-modern-form {\r\n  width: 100%;\r\n}\r\n\r\n/* Form Content Wrapper */\r\n.admin-form-content-wrapper {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 4rem;\r\n  margin-bottom: 2rem;\r\n  position: relative;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 1px;\r\n    background: #9ca3afa1;\r\n    transform: translateX(-50%);\r\n  }\r\n\r\n  @media (max-width: 1400px) {\r\n    grid-template-columns: 1fr 450px;\r\n    gap: 3rem;\r\n  }\r\n\r\n  @media (max-width: 1200px) {\r\n    grid-template-columns: 1fr;\r\n    gap: 2rem;\r\n  }\r\n}\r\n\r\n/* Form Columns */\r\n.admin-form-left-column {\r\n  flex: 1;\r\n}\r\n\r\n.admin-form-right-column {\r\n  width: 100%;\r\n\r\n  @media (max-width: 1400px) {\r\n    max-width: 450px;\r\n  }\r\n\r\n  @media (max-width: 1200px) {\r\n    max-width: none;\r\n  }\r\n}\r\n\r\n/* Form Sections */\r\n.admin-form-section {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* Bottom Submit Button */\r\n.admin-form-actions-bottom {\r\n  text-align: center;\r\n  padding: 2rem 0 1rem;\r\n  border-top: 2px solid var(--border-light);\r\n  margin-top: 2rem;\r\n}\r\n\r\n/* Compact Grid System */\r\n.admin-form-grid {\r\n  display: grid;\r\n  gap: 1rem;\r\n}\r\n\r\n.admin-form-grid-two-columns {\r\n  display: grid;\r\n  gap: 1rem;\r\n  grid-template-columns: 1fr 1fr;\r\n\r\n  @media (max-width: 768px) {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n}\r\n\r\n.admin-form-grid-three-columns {\r\n  display: grid;\r\n  gap: 1rem;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n\r\n  @media (max-width: 1024px) {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n}\r\n\r\n/* Compact Form Item Styling */\r\n.admin-modern-form .ant-form-item {\r\n  margin-bottom: 0.75rem;\r\n\r\n  .ant-form-item-label {\r\n    padding-bottom: 0.25rem;\r\n    margin-bottom: 0;\r\n\r\n    > label {\r\n      font-weight: 500;\r\n      color: var(--text-primary);\r\n      font-size: 0.875rem;\r\n      text-transform: none;\r\n      letter-spacing: 0;\r\n      line-height: 1.4;\r\n\r\n      &::after {\r\n        content: none;\r\n      }\r\n\r\n      &.ant-form-item-required::before {\r\n        content: \"*\";\r\n        color: var(--danger-color);\r\n        font-weight: bold;\r\n        margin-right: 4px;\r\n        font-size: 0.9rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .ant-form-item-control {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n/* Compact Input Styling */\r\n.admin-modern-form .ant-input,\r\n.admin-modern-form .ant-input-password,\r\n.admin-modern-form .ant-select-selector,\r\n.admin-modern-form .ant-picker {\r\n  border: 1px solid #d1d5db !important;\r\n  border-radius: var(--radius-md);\r\n  padding: 8px 12px;\r\n  font-size: 0.9rem;\r\n  font-weight: 400;\r\n  transition: all 0.2s ease;\r\n  background: var(--surface-white);\r\n  height: 38px;\r\n  line-height: 1.4;\r\n\r\n  &:hover {\r\n    border-color: var(--primary-light);\r\n    box-shadow: 0 0 0 1px rgba(239, 130, 0, 0.2);\r\n  }\r\n\r\n  &:focus,\r\n  &.ant-input-focused,\r\n  &.ant-select-focused {\r\n    border-color: var(--primary-color);\r\n    box-shadow: 0 0 0 2px rgba(239, 130, 0, 0.2);\r\n  }\r\n}\r\n\r\n/* Fix password input alignment */\r\n.admin-modern-form .ant-input-password {\r\n  .ant-input {\r\n    border: none !important;\r\n    padding: 0;\r\n    height: auto;\r\n    line-height: 1.4;\r\n    display: flex;\r\n    align-items: center;\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  .ant-input-suffix {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n/* Enhanced Checkbox and Radio Styling */\r\n.admin-modern-form .ant-checkbox-wrapper,\r\n.admin-modern-form .ant-radio-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.75rem 1rem;\r\n  border: 1px solid #9ca3af;\r\n  border-radius: var(--radius-md);\r\n  transition: all 0.2s ease;\r\n  background: var(--surface-gray-50);\r\n\r\n  &:hover {\r\n    background: var(--surface-white);\r\n    border-color: var(--primary-light);\r\n    box-shadow: var(--shadow-sm);\r\n  }\r\n}\r\n\r\n/* Permissions Grid Layout */\r\n.admin-permissions-grid {\r\n  .ant-checkbox-group {\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: 0.75rem;\r\n\r\n    @media (max-width: 768px) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n}\r\n\r\n.admin-modern-form .ant-checkbox-wrapper {\r\n  width: 100%;\r\n\r\n  .ant-checkbox {\r\n    .ant-checkbox-inner {\r\n      width: 20px;\r\n      height: 20px;\r\n      border-radius: var(--radius-sm);\r\n      border: 2px solid #9ca3af !important;\r\n      transition: all 0.2s ease;\r\n\r\n      &::after {\r\n        width: 6px;\r\n        height: 10px;\r\n        border-width: 0 3px 3px 0;\r\n      }\r\n    }\r\n\r\n    &.ant-checkbox-checked .ant-checkbox-inner {\r\n      background: var(--primary-gradient);\r\n      border-color: var(--primary-color);\r\n    }\r\n  }\r\n\r\n  span:last-child {\r\n    font-weight: 500;\r\n    color: var(--text-primary);\r\n    margin-left: 0.5rem;\r\n  }\r\n}\r\n\r\n/* Submit Button */\r\n.admin-create-btn {\r\n  min-width: 220px;\r\n  height: 44px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  text-transform: none;\r\n  letter-spacing: 0;\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  background: var(--primary-color);\r\n  color: white;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  transition: all 0.2s ease;\r\n\r\n  &:hover {\r\n    background: #d97706;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\r\n  }\r\n\r\n  &:active {\r\n    transform: translateY(1px);\r\n  }\r\n\r\n  &[disabled] {\r\n    background: var(--text-muted);\r\n    box-shadow: none;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n/* Custom Editor Styling */\r\n.admin-custom-editor-wrapper {\r\n  border: 2px solid var(--border-light);\r\n  border-radius: var(--radius-lg);\r\n  overflow: hidden;\r\n  transition: all 0.2s ease;\r\n  background: var(--surface-white);\r\n\r\n  &:hover {\r\n    border-color: var(--primary-light);\r\n    box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);\r\n  }\r\n\r\n  &:focus-within {\r\n    border-color: var(--primary-color);\r\n    box-shadow: 0 0 0 4px rgb(239 130 0 / 0.15);\r\n  }\r\n\r\n  .admin-form-right-column & {\r\n    margin-top: 0;\r\n    min-height: 200px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
